export default "__VITE_ASSET__CPVSS6Fj__"